const isTest = process.env.GATSBY_ENV === "test"

export const POSTBACK_BASE_URL = isTest
  ? "https://test-partnership-ecom-postback-api-k8s.sovcombank.group/api/v1/postback"
  : "https://cpa.sovcombank.ru/api/v1/postback"
